export const courseProperties = {
  c_type: "Online course",
  c_duration: "3 hours",
  c_award: "Certificate",
  c_language: "Full audio & text",
  c_level: "Introductory",
  c_access: "Lifetime access",
  program_text: "<p>This course is part of the</p>",
};

export const courseFieldsMaxLength = {
  title: 70,
  intro_text: 500,
  skills_text: 500,
  program_text: 100,
  about_text: 800,
};

export const courseAdvantages = [
  {
    icon_path: "/static/icons/school-online.svg",
    icon_number: 1,
    icon_text: "Click through engaging and award winning course content.",
    icon_title: "100% Online",
  },
  {
    icon_path: "/static/icons/clock-dark.svg",
    icon_number: 2,
    icon_text: "Immediate start: study when, where, and how fast you want.",
    icon_title: "100% self-paced",
  },
  {
    icon_path: "/static/icons/certificate.svg",
    icon_number: 3,
    icon_text:
      "Download your personal certificate upon completion of this course.",
    icon_title: "Get your certificate",
  },
];
